import React, { FC, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Input, Button, Modal, Row, Col, Upload } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { UPLOAD_MEDIA } from "../../reducers/authReducer";
import { RootState } from "reducers/rootReducer";

const UploadFileModal: FC<{ isBio?: boolean, onClose?: () => void }> = ({ isBio, onClose }) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const [fileList, setFileList] = useState<any>([]);
  const [location, setLocation] = useState<any>();
  const { selectedItem } = useSelector(
    (state: RootState) => state.search
  );
  const { userBds } = useSelector((state: RootState) => state.auth);
  const [saving, setSaving] = useState<boolean>(false);
  const { fileToSend } = useSelector((state: RootState) => state.message);
  const sentCount = useRef(0);


  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };
  const dispatch = useDispatch();
  const handleOk = () => {
    fileList.map((file) => {
      let form = new FormData();
      form.append("file", file);
      form.append("info", JSON.stringify({
        pageId: selectedItem.pageId, userId: localStorage.getItem('RID'), location: location ? {
          coordinates: location, clbs: {
            tags: ['type:media', `org:${selectedItem?.persistent?.static?.iotAsset?.config?.configUserCudbServiceId}`, `name:${file.name}`]
          }
        } : undefined
      }));

      console.log('selected item', file)
      dispatch(UPLOAD_MEDIA({ form, isBio }));
    })
    setSaving(true);
  };

  useEffect(() => {
    getCurrentLocation()
  }, []);

  useEffect(() => {
    if (fileToSend) {
      sentCount.current += 1;
      if (sentCount.current === fileList.length) {
        setIsModalVisible(false);
        onClose && onClose();
      }
    }
  }, [fileToSend]);

  const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          setLocation({
            lat: position?.coords?.latitude,
            long: position?.coords?.longitude,
          });
        });
      } else {
        reject("Geolocation is not supported by this browser.");
      }
    });
  };

  useEffect(() => {
    getCurrentLocation()
  }, []);

  return (
    <Modal
      title="Upload a file"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <Upload
        maxCount={10}
        multiple={true}
        beforeUpload={async (file, list) => {
          setFileList([...fileList, ...list])
          return false;
        }}
      >
        <div>Drop your file here (or click)</div>
      </Upload>
      <Row className="action-grp mt-4">
        <Col span={14} className="pr-2">
          <Button
            className="beam-btn green-btn cover w-full"
            onClick={handleOk}
            loading={saving}
            disabled={fileList.length === 0}
          >
            Upload
          </Button>
        </Col>
        <Col span={10} className="pl-2">
          <Button
            className="beam-btn orange-btn bordered w-full"
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default UploadFileModal;
